import { truncateTo2dp } from './helpers/general';
import i18n from 'i18n';

export type average_fuel_key_to_use = 'avg_speed' | 'average_fuel_rate';
export interface EventsForFuelAnalyticsInterface {
  key: string;
  name: string;
  average_fuel_key_to_use: average_fuel_key_to_use;
  value_present?: boolean;
}
export const eventsForFuelAnalytics: EventsForFuelAnalyticsInterface[] = [
  {
    key: 'overspeed',
    name: 'overspeeding',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: true,
  },
  {
    key: 'underspeed',
    name: 'underspeeding',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: true,
  },
  {
    key: 'incorrect_gear',
    name: 'incorrect gear:speed ratio',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: true,
  },
  {
    key: 'short_idling',
    name: 'Idling (lesser than 6 minutes)',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: true,
  },
  {
    key: 'long_idling',
    name: 'Idling (greater than 6 minutes).',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: true,
  },
  {
    key: 'pre_dumping',
    name: 'Queuing - Pre Dumping (shows actual fuel used).',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: false,
  },
  {
    key: 'pre_loading',
    name: 'Queuing - Post Loading (shows actual fuel used).',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: false,
  },
  {
    key: 'road_condition',
    name: 'Wastes due to rough road conditions (shows actual fuel used).',
    average_fuel_key_to_use: 'average_fuel_rate',
    value_present: false,
  },
  {
    key: 'tire_underpressure',
    name: 'Tire Underpressure',
    average_fuel_key_to_use: 'average_fuel_rate' as const,
    value_present: true,
  },
];

export const isNegative = (value: number) => value < 0;

export const getDiffForUtilization = (value: number, baseValue: number) =>
  value === -100 && baseValue === 0 ? value + 100 : value;

export const returnAnalysis = (value: number | string) => {
  const numericValue = Number(value);

  if (isNaN(numericValue) || numericValue === 0) {
    // return '';
    return i18n.t('not_enough_data_to_compare');
  }

  return `${Math.abs(parseFloat(truncateTo2dp(numericValue)))}% ${
    isNegative(numericValue) ? i18n.t('analysis_less') : i18n.t('analysis_more')
  }`;
};

export const isSameValue = (
  baseValue: number,
  percentageDiff: number
): boolean => {
  return percentageDiff === 0 && baseValue !== 0;
};
